import React, { FC, ReactElement, ReactNode } from 'react'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Skeleton from '@material-ui/lab/Skeleton'

type Props = {
    noRows: number
    noColumns: number
}

export const DataTableRowLoader: FC<Props> = ({ noRows, noColumns }: Props): ReactElement => (
    <>
        {[...Array<number>(noRows)].map(
            (_: number, index: number): ReactNode => (
                <TableRow className='rd-table-row rd-table-loader' key={`rd-table-row-loader-${index}`}>
                    {[...Array<number>(noColumns)].map(
                        (_: number, idx: number): ReactElement => (
                            <TableCell key={`rd-table-column-loader-${idx}`}>
                                <Skeleton />
                            </TableCell>
                        )
                    )}
                </TableRow>
            )
        )}
    </>
)
